import { ResultFile } from '@alilc/lowcode-types';
import { createResultFile } from '../../../../../../../utils/resultHelper';

export default function getFile(): [string[], ResultFile] {
    const file = createResultFile(
        'App',
        'js',
        `
import './globalStyle.css';
import {Switch, BrowserRouter} from "react-router-dom";
import {routes, RouteWithSubRoutes} from "@src/routes";

function App() {
  return (
      <div>
        <BrowserRouter>
          <Switch>
            {routes.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
            ))}
          </Switch>
        </BrowserRouter>
      </div>
  );
}

export default App;
    `,
    );

    return [['src'], file];
}




